import { ajax } from '@src/utils'

export default {
  signout: {
    url: '/user/sign/out'
  }
}

export function getPolicyDetail(policyNo) {
  return ajax({
    url: '/policy/detail/' + policyNo + '?isNeedi18nKey=true',
    loading: true,
    method: 'POST'
  })
}

export function getMarketPlans(goodsId) {
  return ajax({
    url: '/market/plans/list',
    loading: true,
    data: {
      goodId: goodsId,
      isNeedI18nKey: true
    },
    method: 'POST'
  })
}

export function getReinstatementBill(policyNo) {
  return ajax({
    url: '/reinstatement/bill',
    method: 'POST',
    data: {
      policyNo
    }
  })
}

export function createReinstateOrder({ policyNo, posTransno }) {
  return ajax({
    url: '/reinstatement/order/create',
    method: 'POST',
    data: {
      policyNo,
      posTransno
    }
  })
}

export function paPlanTransfer({ goodsPlanId = '', planDes }) {
  return ajax({
    url: '/market/planIdTransfer',
    method: 'POST',
    data: {
      goodPlanId: goodsPlanId,
      planDes
    }
  })
}

export function checkCustomer(data) {
  return ajax({
    url: '/user/customer/check',
    method: 'POST',
    data
  })
}

export function checkPromotionCode(promoCode) {
  return ajax({
    url: '/mgm/issueCheck',
    data: {
      promoCode
    }
  })
}

// banca账号激活
export function verifyIdentity(data) {
  return ajax({
    url: '/user/customer/activate',
    method: 'POST',
    data,
    loading: true,
    needHkid: true
  })
}

export function verifyIdentityStatus() {
  return ajax({
    url: '/user/customer/activate/status',
    method: 'POST',
    loading: true
  })
}

export function getUserInfo () {
  return ajax({
    url: '/getUserInfo'
  })
}

export function getCuid () {
  return ajax({
    url: '/file/key',
    data: {}
  })
}

// 动态获取试算因子
export async function getFactorsDynamic(param) {
  let dataSource = []
  const res = await ajax({
    url: '/calculate/factorsDynamic',
    data: param,
    loading: true
  })

  const sortFactors = (arr) => {
    arr.sort((item1, item2) => {
      return item1.orderNum > item2.orderNum ? 1 : -1
    })
  }

  if (res.success) {
    const data = res.value || {}
    dataSource = (data.planFactors && data.planFactors.factorsDetailResDTOList) || []
    sortFactors(dataSource)
    return dataSource
  }
}

export async function premiumForLiability(param) {
  const res = await ajax({
    url: '/calculate/premiumForLiability',
    data: param
  })
  const products = [] // 试算需要的

  if (res.success) {
    // 第一件事是设置好试算接口需要的列表
    const calDetailMap = (res.value && res.value.calDetailMap) || {}
    Object.keys(calDetailMap).forEach((key) => {
      const liabilities = calDetailMap[key]
      const productObj = {
        productId: key,
        liabilities: Object.keys(liabilities).map((lKey) => {
          return {
            liabilityId: lKey,
            SA: String(liabilities[lKey]),
            amount: String(liabilities[lKey]),
            factorParams: {
              SA: String(liabilities[lKey])
            }
          }
        })
      }
      products.push(productObj)
    })
  }

  console.log('products:', products)
  return products
}

// 調用保费试算接口
export async function calculatePremium(params) {
  const { value } =
    (await ajax({
      url: '/calculate/premium',
      loading: true,
      data: params,
      notip: true
    })) || {}
  if (!value) return
  let totalPrice = Number(value.calValue).toFixed(2)
  const valueDiscount = Number(value.valueDiscount).toFixed(2)
  return {
    totalPrice,
    valueDiscount: isNaN(valueDiscount) ? totalPrice : valueDiscount
  }
}

export async function getSARangeAPI(goodsId, goodsPlanId) {
  const res = await ajax({
    url: '/market/sa/range',
    loading: true,
    data: {
      goodsId,
      goodsPlanId
    }
  })
  console.log('res: ', res);
  return res && res.value
}

// 经济一周活动页面访问上报
export function reportViewTimes(activity) {
  return ajax({
    url: `/activity/${activity}/page/view`,
    notip: true
  })
}

// 动态获取优惠码
export async function getDynamicPromotionCode(activity) {
  const { value } = await ajax({
    url: `/activity/${activity}/promote/code`
  }) || {}
  return value
}

// 获取优惠码详情
export async function getPromotionDetail(data) {
  const { value } = await ajax({
    url: '/campaign/code/detail',
    data
  }) || {}
  return value
}


